"use client";

import { useState, useEffect, useRef } from "react";
import { IoMdArrowDropdown } from "react-icons/io";

export default function YearSelect({ onChange, compact = false, value }) {
  const startYear = 2025;
  const currentYear = new Date().getFullYear();
  const endYear = currentYear + 0;

  const years = Array.from(
    { length: endYear - startYear + 1 },
    (_, i) => startYear + i
  );

  const [open, setOpen] = useState(false);
  const [selectedYear, setSelectedYear] = useState(value || currentYear);

  const dropdownRef = useRef(null);

  // Sync with external value prop
  useEffect(() => {
    if (value !== undefined) {
      setSelectedYear(value);
    }
  }, [value]);

  const handleSelect = (year) => {
    setSelectedYear(year);
    setOpen(false);
    onChange?.(year);
  };

  useEffect(() => {
    const close = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", close);
    return () => document.removeEventListener("mousedown", close);
  }, []);

  return (
    <div className="relative" ref={dropdownRef}>
      <button
        onClick={() => setOpen(!open)}
        className={`flex items-center justify-between rounded-lg shadow-sm
          transition-all bg-gray-100

          ${
            compact
              ? // ⭐ COMPACT FILTER STYLE (matches Last 3/6 Months buttons)
                "px-3 py-2 text-sm border border-gray-300  min-w-[120px]"
              : // ⭐ NORMAL HEADER STYLE
                "w-[180px] bg-gray-100 px-6 py-3 text-base font-semibold text-gray-800"
          }
        `}
      >
        <span
          className={`${
            compact
              ? "text-sm text-gray-700"
              : "text-base text-gray-800 font-semibold"
          }`}
        >
          {selectedYear}
        </span>

        <IoMdArrowDropdown
          className={`text-black ${
            compact ? "text-lg" : "text-xl"
          } transition-transform ${open ? "rotate-180" : ""}`}
        />
      </button>

      {open && (
        <div
          className={`absolute left-0 mt-2 bg-gray-100 border border-gray-200 shadow-lg rounded-[14px] z-50 text-start
            ${compact ? "w-[120px]" : "w-[180px]"}
          `}
        >
          {years.map((year) => (
            <div
              key={year}
              onClick={() => handleSelect(year)}
              className={`px-4 py-2 text-sm cursor-pointer hover:bg-gray-100 ${
                year === selectedYear ? "bg-gray-50 font-semibold" : ""
              }`}
            >
              {year}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
